import { useMemo, useRef } from 'react'
import { Transition } from 'react-transition-group'

import { useStore } from '@/contexts/store'
import useMedia from '@/hooks/useMedia'
import { useLoaderStore } from '@/store/loader'

import Spinner from './spinner'
import { cn } from '@/lib/utils'

const Loader = () => {
  const root = useRef<HTMLDivElement>(null!)
  const isPosterReady = useLoaderStore((state) => state.isPosterReady)
  const heroCanPlay = useLoaderStore((state) => state.heroCanPlay)
  const isMobile = useMedia('only screen and (max-width: 768px)', true)
  const { strings } = useStore()

  const stableSpinner = useMemo(() => <Spinner variant="large" />, [])
  const downloadVideo = useMemo(() => {
    return (
      strings?.menu_assets.list && (
        <div className="absolute left-0 top-0 z-40 size-[1px]">
          {strings?.menu_assets.list.map((item: any) => {
            return (
              <video
                key={item.video.url}
                src={item.video.url}
                controls
                preload="auto"
                muted
                loop
                playsInline
                autoPlay
                className="size-[1px]"
              />
            )
          })}
        </div>
      )
    )
  }, [strings?.menu_assets?.list])

  return (
    <Transition
      nodeRef={root}
      in={isMobile ? !isPosterReady : !heroCanPlay}
      timeout={{
        enter: 0,
        exit: 500
      }}
      unmountOnExit
    >
      {(state) => {
        return (
          <div
            ref={root}
            className={cn(
              'fixed left-0 top-0 z-[200] h-full w-full',
              'flex items-center justify-center bg-black',
              'transition-opacity duration-1000 ease-in-out-cubic',
              {
                'opacity-0 duration-0': state === 'entering',
                'opacity-100 delay-200': state === 'entered',
                'opacity-0': state === 'exiting'
              }
            )}
          >
            <svg className="block h-[1.2rem] w-[4.8rem] fill-white">
              <use xlinkHref="#logo-icon"></use>
            </svg>
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              {stableSpinner}
            </div>
            {downloadVideo}
          </div>
        )
      }}
    </Transition>
  )
}

export default Loader
